import React from 'react';
import { posts } from '../data/posts';
import { useTranslation } from '../context/TranslationContext';
import { NoteList } from '../components/Notes';
import useDocumentTitle from '../hooks/useDocumentTitle';

export default function Blog() {
  const { lang } = useTranslation();
  const es = lang !== 'en';
  useDocumentTitle(es ? 'Cuaderno · Qyntix' : 'Notebook · Qyntix');

  return (
    <main id="main">
      <header className="page-head">
        <div className="wrap">
          <h1 className="t-hero">{es ? 'Cuaderno' : 'Notebook'}</h1>
          <p className="t-lead">
            {es
              ? 'Lo que escribimos sobre software, IA y lo que vemos en los proyectos de despachos, estudios de marketing y empresas de salud.'
              : 'What we write about software, AI and what we see in projects for law firms, marketing studios and health companies.'}
          </p>
        </div>
      </header>
      <div className="wrap">
        <NoteList items={posts} lang={lang} />
      </div>
    </main>
  );
}
